import React from 'react';

const AgeVerification = () => {
  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '20px',
      lineHeight: '1.6',
      color: '#333'
    }}>
      <h1 style={{ 
        textAlign: 'center', 
        color: '#2c3e50',
        marginBottom: '30px',
        fontSize: '28px'
      }}>
        年齢認証について
      </h1>

      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '25px',
        borderRadius: '8px',
        marginBottom: '30px',
        border: '1px solid #e9ecef'
      }}>
        <h2 style={{ 
          color: '#e74c3c', 
          marginBottom: '20px',
          fontSize: '22px'
        }}>
          重要なお知らせ
        </h2>
        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
          当サイトは18歳以上の方のみご利用いただけます。
        </p>
        <p style={{ fontSize: '16px' }}>
          年齢確認ができない場合は、サービスをご利用いただけません。
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          年齢認証の必要性
        </h3>
        <p style={{ marginBottom: '15px' }}>
          当サイトは、出会い系サービスとして運営しております。利用者の皆様の安全と適切なサービスの提供のため、
          年齢認証を実施しております。
        </p>
        <ul style={{ 
          marginLeft: '20px',
          marginBottom: '15px'
        }}>
          <li>18歳未満の方の利用を防止するため</li>
          <li>適切な年齢層でのマッチングを実現するため</li>
          <li>法的要件を満たすため</li>
          <li>利用者の安全を確保するため</li>
        </ul>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          認証方法
        </h3>
        <p style={{ marginBottom: '15px' }}>
          以下のいずれかの方法で年齢認証を行っていただきます：
        </p>
        <div style={{
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <h4 style={{ 
            color: '#27ae60', 
            marginBottom: '10px',
            fontSize: '18px'
          }}>
            1. 運転免許証による認証
          </h4>
          <p style={{ marginBottom: '15px' }}>
            運転免許証の表面を撮影し、アップロードしていただきます。
            個人情報部分は適切にマスキング処理を行います。
          </p>

          <h4 style={{ 
            color: '#27ae60', 
            marginBottom: '10px',
            fontSize: '18px'
          }}>
            2. マイナンバーカードによる認証
          </h4>
          <p style={{ marginBottom: '15px' }}>
            マイナンバーカードの表面を撮影し、アップロードしていただきます。
            マイナンバー部分は適切にマスキング処理を行います。
          </p>

          <h4 style={{ 
            color: '#27ae60', 
            marginBottom: '10px',
            fontSize: '18px'
          }}>
            3. パスポートによる認証
          </h4>
          <p style={{ marginBottom: '15px' }}>
            パスポートの顔写真ページを撮影し、アップロードしていただきます。
            パスポート番号部分は適切にマスキング処理を行います。
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          個人情報の取り扱いについて
        </h3>
        <p style={{ marginBottom: '15px' }}>
          年齢認証で取得した個人情報は、以下の目的でのみ使用いたします：
        </p>
        <ul style={{ 
          marginLeft: '20px',
          marginBottom: '15px'
        }}>
          <li>年齢確認のため</li>
          <li>本人確認のため</li>
          <li>不正利用の防止のため</li>
        </ul>
        <p style={{ 
          backgroundColor: '#fff3cd',
          padding: '15px',
          borderRadius: '6px',
          border: '1px solid #ffeaa7',
          color: '#856404'
        }}>
          <strong>重要：</strong>
          認証用にアップロードされた画像は、認証完了後24時間以内に完全に削除いたします。
          当社は、認証目的以外での個人情報の使用は一切いたしません。
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          認証の流れ
        </h3>
        <div style={{
          backgroundColor: '#fff',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #dee2e6'
        }}>
          <ol style={{ marginLeft: '20px' }}>
            <li style={{ marginBottom: '10px' }}>
              利用規約に同意し、アカウントを作成
            </li>
            <li style={{ marginBottom: '10px' }}>
              年齢認証ページにアクセス
            </li>
            <li style={{ marginBottom: '10px' }}>
              認証方法を選択（運転免許証、マイナンバーカード、パスポート）
            </li>
            <li style={{ marginBottom: '10px' }}>
              身分証明書を撮影し、アップロード
            </li>
            <li style={{ marginBottom: '10px' }}>
              個人情報部分をマスキング処理
            </li>
            <li style={{ marginBottom: '10px' }}>
              認証情報を送信
            </li>
            <li style={{ marginBottom: '10px' }}>
              審査（通常24時間以内）
            </li>
            <li style={{ marginBottom: '10px' }}>
              認証完了通知
            </li>
          </ol>
        </div>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3 style={{ 
          color: '#2c3e50', 
          marginBottom: '15px',
          fontSize: '20px'
        }}>
          注意事項
        </h3>
        <div style={{
          backgroundColor: '#f8d7da',
          padding: '20px',
          borderRadius: '6px',
          border: '1px solid #f5c6cb',
          color: '#721c24'
        }}>
          <ul style={{ marginLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>
              虚偽の情報を提供した場合、アカウントが停止される場合があります
            </li>
            <li style={{ marginBottom: '8px' }}>
              18歳未満の方の利用は法律で禁止されています
            </li>
            <li style={{ marginBottom: '8px' }}>
              認証が完了するまで、サービスの一部機能が制限されます
            </li>
            <li style={{ marginBottom: '8px' }}>
              認証に失敗した場合、再度認証を行っていただく必要があります
            </li>
          </ul>
        </div>
      </div>

      <div style={{
        backgroundColor: '#d4edda',
        padding: '20px',
        borderRadius: '6px',
        border: '1px solid #c3e6cb',
        color: '#155724',
        textAlign: 'center'
      }}>
        <h3 style={{ marginBottom: '15px' }}>お問い合わせ</h3>
        <p style={{ marginBottom: '10px' }}>
          年齢認証についてご不明な点がございましたら、お気軽にお問い合わせください。
        </p>
        <p style={{ fontWeight: 'bold' }}>
          お問い合わせ先：nwo123123@yahoo.co.jp
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;
